import React from 'react';
import './Testimonials.css';

const Testimonials = ({ t }) => {
  const avatars = [
    <i className="fas fa-user-circle"></i>,
    <i className="fas fa-user-circle"></i>,
    <i className="fas fa-user-circle"></i>
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{t.tag}</span>
          <h2>{t.title}</h2>
        </div>
        <div className="testimonials-grid">
          {t.list.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-avatar">{avatars[index]}</div>
              <div className="rating">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fas fa-star"></i>
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <h4>{testimonial.name}</h4>
                <span>{testimonial.country}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
